export default "__VITE_ASSET__iuOa1V6u__"